import { default as _91shortlinkId_93FWR6gV5PPPMeta } from "/var/www/minisite/pages/apply/[shortlinkId].vue?macro=true";
import { default as _91shortlinkId_93VicJ5HZ36sMeta } from "/var/www/minisite/pages/jobs/[shortlinkId].vue?macro=true";
import { default as indexxeDu1dYvTbMeta } from "/var/www/minisite/pages/thank-you/index.vue?macro=true";
import { default as _91shortlinkId_93Aso9yePYbXMeta } from "/var/www/minisite/pages/vacancy/[shortlinkId].vue?macro=true";
export default [
  {
    name: _91shortlinkId_93FWR6gV5PPPMeta?.name ?? "apply-shortlinkId",
    path: _91shortlinkId_93FWR6gV5PPPMeta?.path ?? "/apply/:shortlinkId()",
    meta: _91shortlinkId_93FWR6gV5PPPMeta || {},
    alias: _91shortlinkId_93FWR6gV5PPPMeta?.alias || [],
    redirect: _91shortlinkId_93FWR6gV5PPPMeta?.redirect || undefined,
    component: () => import("/var/www/minisite/pages/apply/[shortlinkId].vue").then(m => m.default || m)
  },
  {
    name: _91shortlinkId_93VicJ5HZ36sMeta?.name ?? "jobs-shortlinkId",
    path: _91shortlinkId_93VicJ5HZ36sMeta?.path ?? "/jobs/:shortlinkId()",
    meta: _91shortlinkId_93VicJ5HZ36sMeta || {},
    alias: _91shortlinkId_93VicJ5HZ36sMeta?.alias || [],
    redirect: _91shortlinkId_93VicJ5HZ36sMeta?.redirect || undefined,
    component: () => import("/var/www/minisite/pages/jobs/[shortlinkId].vue").then(m => m.default || m)
  },
  {
    name: indexxeDu1dYvTbMeta?.name ?? "thank-you",
    path: indexxeDu1dYvTbMeta?.path ?? "/thank-you",
    meta: indexxeDu1dYvTbMeta || {},
    alias: indexxeDu1dYvTbMeta?.alias || [],
    redirect: indexxeDu1dYvTbMeta?.redirect || undefined,
    component: () => import("/var/www/minisite/pages/thank-you/index.vue").then(m => m.default || m)
  },
  {
    name: _91shortlinkId_93Aso9yePYbXMeta?.name ?? "vacancy-shortlinkId",
    path: _91shortlinkId_93Aso9yePYbXMeta?.path ?? "/vacancy/:shortlinkId()",
    meta: _91shortlinkId_93Aso9yePYbXMeta || {},
    alias: _91shortlinkId_93Aso9yePYbXMeta?.alias || [],
    redirect: _91shortlinkId_93Aso9yePYbXMeta?.redirect || undefined,
    component: () => import("/var/www/minisite/pages/vacancy/[shortlinkId].vue").then(m => m.default || m)
  }
]